import { attachDialog } from '../../util/dialog_helpers.js';
import { getUserPrefs } from '../../util/user_prefs_util.js';

import { attachEventHandlers } from '../mixins/ConfirmTypekitOnboardDialog.js';

/**
 * Should the user see the Typekit onboarding modal?
 * @return {Boolean}
 */
async function shouldShowTypekitOnboardDialog() {
  const userPrefs = await getUserPrefs();
  return !userPrefs.hideTypekitOnboardModal;
}


/**
 * Show the Typekit onboarding dialog
 * Ensure the promise resolves when the dialog is closed or
 * if we don't need to show the dialog so that add to web project
 * dialog can be opened
 * @return {Promise<void>}
 */
export const showTypekitOnboardDialog = async () => {
  const shouldShow = await shouldShowTypekitOnboardDialog();
  if (!shouldShow) {
    return Promise.resolve();
  }

  try {
    const { dialog, dialogPromise } = await attachDialog('typekit_onboard_dialog') as { dialog: HTMLElement, dialogPromise: Promise<void> };

    attachEventHandlers(dialog);

    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
